import { createFileRoute } from "@tanstack/react-router"

import { InceptionPanel } from "@/pages/InceptionPanel"

export const Route = createFileRoute("/monitoring/inception")({
  component: InceptionPanel,
})
